<template>
    <div class="helper-page">
        <template v-for="item in stepOptions">
            <step-component
                :key="'STEP_OPTION_ITEM_KEY_'+item.title"
                :title="item.title"
                :sub-title="item.subTitle"
                :img="item.img"/>
        </template>
    </div>
</template>

<script>
import StepComponent from '@/views/helper/StepComponent'
export default {
    name: 'dzdp',
    components: { StepComponent },
    data () {
        return {
            stepOptions: [
                {
                    title: '第一步',
                    subTitle: '点击大众点评，进入“我的”页面，点击“个人主页”。',
                    img: require('@/assets/dzdp/dzdp01.png')
                },
                {
                    title: '第二步',
                    subTitle: '点击右侧图标。',
                    img: require('@/assets/dzdp/dzdp02.png')
                },
                {
                    title: '第三步',
                    subTitle: '点击“复制链接”即可获得链接',
                    img: require('@/assets/dzdp/dzdp03.png')
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>
